interface IRemoteLockVehicle {
  smartCarVehicleID?: string | null;
  teltonikaDeviceId?: string | null;
  volterasVehicleId?: string | null;
  isKeylessSupport?: boolean | null;
}

// Vehicles locked/unlocked from the app: Smartcar, or Teltonika / Volteras with keyless support enabled
export function isRemoteLockVehicle(vehicle?: IRemoteLockVehicle | null): boolean {
  return Boolean(vehicle?.smartCarVehicleID) ||
    Boolean(vehicle?.isKeylessSupport && (vehicle?.teltonikaDeviceId || vehicle?.volterasVehicleId));
}
